module.exports = __webpack_public_path__ + "img/Conversational_form.f40f8e15.gif";